import { render, staticRenderFns } from "./register.vue?vue&type=template&id=77453986&scoped=true&"
import script from "./register.vue?vue&type=script&lang=js&"
export * from "./register.vue?vue&type=script&lang=js&"
import style0 from "./register.vue?vue&type=style&index=0&id=77453986&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77453986",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77453986')) {
      api.createRecord('77453986', component.options)
    } else {
      api.reload('77453986', component.options)
    }
    module.hot.accept("./register.vue?vue&type=template&id=77453986&scoped=true&", function () {
      api.rerender('77453986', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/register.vue"
export default component.exports